import { useCssVars as _useCssVars, unref as _unref } from 'vue';
import { useNetwork } from '@vueuse/core';
import HeaderBar from '../components/common/HeaderBar.vue';
import SlideBar from '../components/common/SlideBar.vue';
import FeedbackBox from '../components/common/feedback/FeedbackBox.vue';
import SvipTag from '../components/svip/SvipTag.vue';
import { useSlides, useHeaders } from '../state';
import InternetDisconnected from '../views/InternetDisconnected.vue';


import { ref, reactive } from 'vue';
// 侧边栏宽度

export default {
  __name: 'IndexLayout',
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    _useCssVars(_ctx => ({
      "3941286e": _unref(headerHeight)
    }));
    const slideWidth = ref(`${useSlides.width}px`);
    // 头部导航栏高度
    const headerHeight = ref(`${useHeaders.height}px`);
    // 网络状态
    const network = reactive(useNetwork());
    const __returned__ = {
      slideWidth,
      headerHeight,
      network,
      get useNetwork() {
        return useNetwork;
      },
      HeaderBar,
      SlideBar,
      FeedbackBox,
      SvipTag,
      get useSlides() {
        return useSlides;
      },
      get useHeaders() {
        return useHeaders;
      },
      InternetDisconnected
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
};